import React, { FC } from 'react';
import { Icon, IconProps } from '../Icon';

export const Search: FC<IconProps> = (props) => (
  <Icon {...props}>
    <path
      fill="currentColor"
      d="M13.5 4.5c-4.963 0-9 4.037-9 9 0 4.962 4.037 9 9 9a8.944 8.944 0 0 0 5.483-1.88l6.541 6.541a1.157 1.157 0 1 0 1.637-1.637l-6.54-6.54A8.944 8.944 0 0 0 22.5 13.5c0-4.963-4.038-9-9-9Zm0 2c3.86 0 7 3.14 7 7s-3.14 7-7 7-7-3.14-7-7 3.14-7 7-7Z"
    />
  </Icon>
);
